export default {
      id: "copy-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#copy",
      toString: function () {
        return this.url;
      }
    }